import * as yup from "yup";
import {lazy} from "yup";
import mapValues from "lodash/mapValues";

import store from "store";

import hasTranslationContent from "utils/hasTranslationContent";

// yup schema for the `translations` object of a form built with getTranslationInitialValues.
// The field is only mandatory on the organization default locale: requiring it on every
// locale disables the submit button with an error the user cannot see, since the form only
// renders the locale tab currently selected.
export default function getTranslationsValidationSchema(requiredMessage, fieldName = 'name') {
    return lazy(translations => yup.object(
        mapValues(translations, (translation, locale) => yup.object({
            [fieldName]: isFieldRequired(locale, translation, fieldName)
                ? yup.string().required(requiredMessage)
                : yup.string().nullable(),
        }))
    ));
}

function isFieldRequired(locale, translation, fieldName) {
    const locales = store.getState().currentOrganization?.retrieved?.locales;

    if (!locales) {
        return true;
    }

    // a secondary locale needs the field as soon as it holds something else,
    // otherwise the api would receive an incomplete translation
    return locale === locales[0] || hasTranslationContent(translation, fieldName);
}
